/**
 * StockComponentStatus - Situação de um componente (rastreador/chip) do kit.
 * Bolinha colorida (verde = operacional; âmbar = demais) + texto neutro,
 * usando o catálogo único de rótulos de `stock-presentation`.
 *
 * RELEASE: 2026-10-17 v1.0.0 - Versão inicial (listagem e ficha do Kit).
 */
import { cn } from '@/lib/utils';
import { isStockStatusOperational, stockStatusLabel } from '@/lib/stock-presentation';

export function StockComponentStatus({ kind, status, className }: { kind: 'tracker' | 'chip'; status: string | null | undefined; className?: string }) {
  if (!status) return null;
  const ok = isStockStatusOperational(kind, status);
  return (
    <span className={cn('inline-flex items-center gap-1 text-[10px] text-muted-foreground', className)}>
      <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', ok ? 'bg-success' : 'bg-warning')} aria-hidden />
      {stockStatusLabel(kind, status)}
    </span>
  );
}
